// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1bhRX","requiredAsterisk":"Info_requiredAsterisk__1qXMy"};